export var DataCatalogGrantStatus;
(function (DataCatalogGrantStatus) {
    DataCatalogGrantStatus["DATA_CATALOG_GRANT_STATUS_SCHEDULED"] = "SCHEDULED";
    DataCatalogGrantStatus["DATA_CATALOG_GRANT_STATUS_ACTIVE"] = "ACTIVE";
    DataCatalogGrantStatus["DATA_CATALOG_GRANT_STATUS_EXPIRED"] = "EXPIRED";
})(DataCatalogGrantStatus || (DataCatalogGrantStatus = {}));
